import { StyleSheet, Text, View } from 'react-native';
import type { ReactNode } from 'react';

import { PublicPageShell } from '@/src/components/PublicPageShell';
import type { LegalDocument } from '@/src/features/legal/legal-documents';
import { colors } from '@/src/theme/colors';
import { spacing } from '@/src/theme/spacing';

type LegalDocumentScreenProps = {
  document: LegalDocument;
  afterContent?: ReactNode;
};

export function LegalDocumentScreen({
  afterContent,
  document,
}: LegalDocumentScreenProps) {
  return (
    <PublicPageShell
      title={document.title}
      subtitle={`Version ${document.version}. Effective ${document.effectiveDate}.`}
    >
      <View style={styles.panel}>
        {document.sections.map((section) => (
          <View key={section.title} style={styles.section}>
            <Text style={styles.heading}>{section.title}</Text>
            {section.body.map((paragraph) => (
              <Text key={paragraph} style={styles.paragraph}>
                {paragraph}
              </Text>
            ))}
          </View>
        ))}
      </View>
      {afterContent}
    </PublicPageShell>
  );
}

const styles = StyleSheet.create({
  panel: {
    backgroundColor: colors.surface,
    borderColor: colors.border,
    borderRadius: 8,
    borderWidth: 1,
    gap: spacing.xl,
    padding: spacing.lg,
  },
  section: {
    gap: spacing.sm,
  },
  heading: {
    color: colors.text,
    fontSize: 18,
    fontWeight: '800',
  },
  paragraph: {
    color: colors.text,
    fontSize: 15,
    lineHeight: 22,
  },
});
